import { motion } from 'framer-motion';
import { Bot, Camera, Share2, Handshake } from 'lucide-react';
import { useSiteConfig } from '../../hooks/useSiteConfig';

const iconMap: Record<string, React.ComponentType<{ size?: number; className?: string }>> = {
  Bot,
  Camera,
  Share2,
  Handshake,
};

export default function TeamExpertiseSection() {
  const siteConfig = useSiteConfig();
  const { teamExpertise } = siteConfig;

  return (
    <section className="py-20 md:py-28 bg-deep-navy relative overflow-hidden">
      <div className="absolute inset-0 bg-circuit-grid opacity-30" />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {teamExpertise.sectionTitle}
          </h2>
          <p className="text-base md:text-lg text-neon-cyan-glow mb-6">{teamExpertise.subtitle}</p>
          <p className="text-gray-400 text-sm md:text-base leading-relaxed max-w-3xl mx-auto mb-12">
            {teamExpertise.description}
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-10">
          {teamExpertise.expertise.map((item, index) => {
            const Icon = iconMap[item.icon] || Bot;
            return (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="neon-card rounded-2xl p-6 flex flex-col items-center gap-3"
              >
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-neon-cyan/20 to-neon-purple/20 flex items-center justify-center border border-neon-cyan/30">
                  <Icon size={22} className="text-neon-cyan" />
                </div>
                <span className="text-white font-semibold text-sm md:text-base text-center">
                  {item.label}
                </span>
              </motion.div>
            );
          })}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-neon-gold text-sm md:text-base font-medium italic"
        >
          {teamExpertise.closingLine}
        </motion.p>
      </div>
    </section>
  );
}
